interface ListingCardProps {
  listing: any;
  onClick?: () => void;
}

export default function ListingCard({ listing, onClick }: ListingCardProps) {
  const score = listing.score ?? 0;
  const status = listing.status ?? 'pass';

  // Format price
  const price = listing.price_chf
    ? `CHF ${Number(listing.price_chf).toLocaleString('de-CH')}`
    : listing.rent_gross_chf
    ? `CHF ${Number(listing.rent_gross_chf).toLocaleString('de-CH')}/Mt.`
    : 'Preis auf Anfrage';

  return (
    <div className={`listing-card listing-card--${status}`} onClick={onClick}>
      <div className="listing-card-header">
        <div className={`score-badge score-badge--${status}`}>
          {score}
        </div>
        <div className="listing-card-info">
          <h3 className="listing-title">{listing.title || 'Immobilie'}</h3>
          <p className="listing-location">
            {[listing.city, listing.canton].filter(Boolean).join(', ')}
          </p>
        </div>
      </div>

      <div className="listing-card-details">
        <span className="listing-detail">{price}</span>
        {listing.rooms && <span className="listing-detail">{listing.rooms} Zi.</span>}
        {listing.living_space_m2 && <span className="listing-detail">{listing.living_space_m2} m²</span>}
        {listing.property_type && listing.property_type !== 'other' && (
          <span className="listing-detail listing-type">{listing.property_type}</span>
        )}
      </div>

      {/* Tags */}
      <div className="listing-tags">
        {listing.fulfilled?.map((f: string, i: number) => (
          <span key={i} className="tag tag--pass">{f}</span>
        ))}
        {listing.nearMissReasons?.map((r: any, i: number) => (
          <span key={`n${i}`} className="tag tag--near">{r.message}</span>
        ))}
      </div>
    </div>
  );
}
